import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import '../styles/About.css';          // только локальные стили страницы

/* ───── глобальный шрифт Anybody ───── */
const GlobalStyles = createGlobalStyle`
  @font-face{
    font-family:'Anybody';
    src:url('../assets/fonts/Anybody-Variable.ttf') format('truetype');
    font-weight:100 900;
    font-style:normal;
    font-display:swap;
  }
  body{margin:0;font-family:'Anybody',sans-serif;}
`;

/* ───── компактный чёрный футер ───── */
const FooterBar = styled.footer`
  grid-area: footer;         /* ← привязываем к ячейке grid */
  width:100%;
  background:#000;
  padding:clamp(2rem,4vh,3rem) 0;
  text-align:center;

  h1{
    color:#fff;
    font-family:'Anybody',sans-serif;
    font-weight:900;
    font-size:clamp(2.6rem,8vw,8rem);
    margin:0;
    line-height:1;
  }
`;
export const About = () => (
  <>
  <div className="about-page">
    {/* Desktop-only image instead of text */}
    <img
      src="/assets/editor.png"
      alt="Editor’s Letter"
      className="editor-img"
    />

    {/* Main titles (visible on mobile) */}
    <div className="title editor">EDITOR’S</div>
    <div className="title letter">LETTER</div>

    {/* Author credit (visible on mobile) */}
    <div className="by-text">
      BY GABRIEL<br/>MEALOR-PRITCHARD
    </div>

    {/* Left photo */}
    <img
      src="/assets/aboutus.png"
      alt="About Us"
      className="image-left"
    />

    {/* Editor’s letter text */}
    <div className="main-text">
      <p>Music and fashion have long co-existed, and are found side-by-side in immeasurable amounts of circumstances. From fashion show music to DJs raising the roof at after-party raves that last until the ungodly hours of the morning, sound lifts the fabric of the fashion industry.</p>
      <p>As we know, both industries have long upheld one another, from birthing inspirations for collections to carrying iconic music videos that spiral into viral fashion-hit moments. Clothing and sound are the perfect match.</p>
      <p>As RIFF Magazine emerges and a new wave of sound/style coverage breaks through into the mainstream, the pilot launch of this platform takes us on a journey into the past and the future. Exploring the iconic nightlife of the Britpop era, with an insightful interview with music superstar Martin Green and diving into the intricate world of future technologies in conversation with Kieran Feechan, a Central Saint Martins Master's student, producing 'Aurora'.</p>
      <p>There's always an essence of curiosity, an eager desire to learn. To discover the unknown. The first launch of RIFF Magazine will highlight the importance of the exploration of sound and fashion, the basis of the publication in its entirety. It's almost thrown in our face nowadays, "X artist has been spotted donning X designer" or "Did you see what X was wearing at X event?", though these are interesting questions and everyone is eager to know the latest news, “Dull,” I thought to myself as I scrolled on countless news stories of the same old thing. There's more to just what breaches the surface of the fashion/music worlds.</p>
      <p>RIFF aims to inspire, inform and introduce its readers to the interesting, unique stories that the mass media of today tend to carelessly neglect. Without exhibitions or networking conversations, these stories can be missed. RIFF brings them to the forefront and wishes you enjoy reading this first launch of the publication as much as we enjoyed creating it.</p>
    </div>
  </div>
      <FooterBar>
      <h1>RIFF&nbsp;MAGAZINE</h1>
    </FooterBar>
    </>

);
